import { Turbo } from "@hotwired/turbo-rails"
import "./controllers"
import "flyonui/flyonui"

// Marketing site is single-page; Turbo Drive only adds re-init overhead
// (cookies banner, reveal animations) on what should be native anchor scroll.
Turbo.session.drive = false

// Turbo flips scrollRestoration to "manual"; put it back so the browser
// restores scroll position on reload.
if ("scrollRestoration" in history) {
  history.scrollRestoration = "auto"
}

document.addEventListener("DOMContentLoaded", () => {
  window.HSStaticMethods?.autoInit?.()
})
